/**
 * The chat surface, made a drop target: drop files anywhere on it (the list, the
 * conversation, the artifact panel) and they are staged like a picked file, with a "Drop files to attach"
 * overlay while dragging.
 *
 * This is its own component (not a hook in ChatPage) because useAttachments
 * subscribes to the whole session store, which changes on every streamed delta.
 * Here only this thin wrapper re-renders; `children` keep their element
 * identity, so the thread and composer are not re-rendered by it.
 */
import type { ComponentProps } from 'react';
import { useAttachments } from '../data-access/useAttachments';
import { useFileDrop } from '../hooks/useFileDrop';

export function ChatDropZone({
  children,
  className,
  ...rest
}: ComponentProps<'div'>) {
  const { addFiles } = useAttachments();
  const { isDragging, dropProps } = useFileDrop(
    (files) => void addFiles(files),
  );

  return (
    <div className={`relative ${className ?? ''}`} {...rest} {...dropProps}>
      {isDragging && (
        <div
          className="pointer-events-none absolute inset-2 z-20 flex items-center justify-center rounded-lg border-2 border-border-action border-dashed bg-surface-background/90 font-inter text-content-primary text-sm"
          data-testid="chat-drop-overlay"
        >
          Drop files to attach
        </div>
      )}
      {children}
    </div>
  );
}
